<template>
<div>
  <el-container>
    <el-main>
      <el-form label-position="right" label-width="120px">
        <el-form-item>
          <el-button size="mini" type="primary" @click="submitTree">生成菜单</el-button>
          <el-button size="mini" type="primary" @click="restTree">重置菜单</el-button>
        </el-form-item>
        <el-form-item>
          <div class="row tree-layout">
            <div class="tree-menu" ref="scroll1" @scroll="scroll">
              <div class="tree-menu-header">本地菜单</div>
              <el-tree
                :data="tree"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false"
                :render-content="renderContent">
              </el-tree>
            </div>
            <div class="tree-menu" ref="scroll2" @scroll="scroll">
              <div class="tree-menu-header">线上菜单</div>
              <el-tree
                :data="os_tree"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false">
              </el-tree>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</div>
</template>

<script>
import tree from "../../../assets/js/tree";
export default {
  name: "CreateTreeMenu",
  data(){
    return{
      url:'',
      url1:'',
      tree:JSON.parse(JSON.stringify(tree)),
      os_tree:[],
    }
  },
  mounted() {
    this.url = this.$myhttp.defaults.baseURL + "/admin/posts";
    this.url1 = this.$myhttp.defaults.baseURL;
    this.getData()
  },
  methods:{
    getData(){
      var that=this;
      that.$myhttp.get('admin/getMenuAllTree',{params:{is_reload:1}}).then(({data}=ret)=>{
        if(data.code&&data.data){
          that.os_tree=data.data;
        }else {
          that.$msgbox.alert(data.msg||'获取线上菜单')
        }
      })
    },
    submitTree(){
      var that=this;
      let f_data=this.getCreateMenuTree();
      that.$myhttp.post('admin/Config/createTreeMenu',{tree:JSON.stringify(f_data)}).then(({data}=ret)=>{
        if(data.code){
          that.$msgbox.alert('生成成功')
          // ERP.initAPP();
          that.getData();
        }else {
          that.$msgbox.alert(data.msg||'生成失败')
        }
      })
    },

    restTree(){
      this.tree=JSON.parse(JSON.stringify(tree))
    },

    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      children.splice(index, 1);
    },

    renderContent(h, { node, data, store }) {
      return (
        <div class="custom-tree-node">
            <span>{node.label}</span>
            <span>
              <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>移除</el-button>
            </span>
          </div>);
    },

    getCreateMenuTree(){
      let data=JSON.parse(JSON.stringify(this.tree))
      console.log(data);
      let menu_list=[];
      function getList(list=[]) {
        list.map(ret=>{

          //      id      varchar(20)          null comment '顶级路由id',
          //     label   varchar(20)          null comment '名称',
          //     icon    varchar(130)         null comment '图标',
          //     path    varchar(80)          null comment '路由',
          //     pid     varchar(20)          null comment '顶级路由id',
          //     is_menu tinyint(1) default 1 null comment '判断是否为目录菜单（0=不是，1=是）'
          let obj_item={};
          obj_item.id=ret.id||'';
          obj_item.label=ret.label||'';
          obj_item.icon=ret.icon||'';
          obj_item.path=ret.path||'';
          obj_item.pid=ret.pid||0;
          obj_item.is_menu=ret.is_menu?1:0;
          menu_list.push(obj_item)
          ret.children&&ret.children.length&&getList(ret.children);
        })
      }
      getList(data)

      let fdata=[]
      menu_list.map(ret=>{
        fdata.push({
          id:ret.id,
          label:ret.label,
          icon:ret.icon,
          path:ret.path,
          pid:ret.pid,
          is_menu:ret.is_menu
        })
      })
      return fdata;
    },
    scroll(e){
      this.$refs.scroll1.scrollTop=e.target.scrollTop
      this.$refs.scroll2.scrollTop=e.target.scrollTop
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 120px;
  height: 45px;
  line-height: 50px;
  vertical-align: top;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 120px;
  height: 45px;
  margin: 0 8px 8px 0;
  display: inline-block;
  //line-height: 45px;
  vertical-align: top;
}
.tree-layout{

}

.tree-menu{
  height: 80vh;
  width: 500px;
  overflow-y: scroll;
}
.tree-menu-header{
  text-align: center;
  background-color: #5a9ffd;
  color: white;
  padding: 2px 0;
}
/deep/ .custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.el-button--primary,.el-button--success,.el-button--danger {
  color: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/CreateTreeMenu.vue